import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdTeasers } from "./IdTeasers";
export var teaserLocaMap = new Map([
    [
        IdTeasers.PlayerLevelTooLowCoop,
        {
            description: IdLoca.tournamentTeaser_levelTooLow_coop_desc,
            title: IdLoca.coopLeague,
        },
    ],
    [
        IdTeasers.PlayerLevelTooLowPlayerLeague,
        {
            description: IdLoca.tournamentTeaser_levelTooLow_player_desc,
            title: IdLoca.playerLeague,
        },
    ],
    [
        IdTeasers.NoCoopLeagueRunning,
        {
            description: IdLoca.tournamentTeaser_nothingRunning_desc,
            title: IdLoca.coopLeague,
        },
    ],
    [
        IdTeasers.NoPlayerLeagueRunning,
        {
            description: IdLoca.tournamentTeaser_nothingRunning_desc,
            title: IdLoca.playerLeague,
        },
    ],
    [
        IdTeasers.PlayerHasNoCoop,
        {
            description: IdLoca.tournamentTeaser_joinCoop_desc,
            title: IdLoca.tournamentMenu_coop_title,
        },
    ],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/teaserLocaMap.ts
// module id = 945
// module chunks = 3